import categoryService from "app/common/services/categoryService";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { getCategoryData } from "./getCategoryData";

export const getInitialState = () => {
    const params = proNavigator.getParams();
    const { category, initialDomains } = params;
    if (!category) {
        return {
            domains: initialDomains?.split(",")?.map((domain) => ({ domain })) ?? [],
            segments: [],
            isEditMode: false,
        };
    }

    const categoryObject = categoryService.categoryQueryParamToCategoryObject(category);

    // `isEditMode` tracks the presence of the param, not whether it resolved: an industry the
    // builder cannot parse is still an edit, and must not be answered with a flow that would
    // create a second industry instead of changing this one.
    if (!categoryObject) {
        return {
            country: 999,
            domains: [],
            categoryObject: null,
            segments: [],
            isEditMode: true,
        };
    }

    const { domains, country, segments } = getCategoryData(categoryObject);
    return { country, domains, categoryObject, segments, isEditMode: true };
};
